import { useState, useEffect } from 'react'
import localforage from 'localforage'
import { flatten, isNil, pipe, prepend, reject, take } from 'ramda'
import pclnExperimentation from '@pcln/experimentation'

const ONE_DAY = 24 * 60 * 60 * 1000
const TWO_DAYS = ONE_DAY * 2
const ONE_WEEK = ONE_DAY * 7
const _48_HOURS = '48_HRS'
const _ONE_WEEK = '1_WEEK'
const FOREVER = 'FOREVER'

export function useSavedSearch (data, experimentCode, setiTest = 'DEFAULT') {
  const [isValid, setIsValid] = useState(true)
  useEffect(() => {
    let timespan
    switch (setiTest) {
      case _48_HOURS:
        timespan = TWO_DAYS
        break
      case _ONE_WEEK:
        timespan = ONE_WEEK
        break
      case FOREVER:
      default:
        timespan = null // DEFAULT bucket should always fire
    }

    if (data === null) {
      setIsValid(false)
      return
    }

    // show default and don't fire impression if timeframe expired
    let isWithinRange = true
    const { timestamp } = data
    if (timespan && timestamp) {
      const now = Date.now()
      if (now - timestamp > timespan) {
        isWithinRange = false
      }
    }

    if (!isWithinRange) {
      setIsValid(false)
    } else {
      pclnExperimentation.fireImpression(experimentCode)
      setIsValid(setiTest !== 'DEFAULT')
    }
  }, [data, experimentCode, setiTest])

  return isValid
}

export async function getPersistedSearchDataByKeys (keys, sort = false) {
  const promiseResultsArray = await Promise.all(keys.map(getPersistedSearchData))
  const results = pipe(flatten, reject(isNil))(promiseResultsArray)

  // sort is by most recently saved
  if (sort) {
    return results.sort((a, b) => b.timestamp - a.timestamp)
  }

  return results
}

export function getPersistedSearchData (key) {
  return localforage.getItem(key)
}

export async function persistSearchData (key, data) {
  const timestamp = Date.now()
  const recentSearch = { ...data, timestamp }

  try {
    const recentSearches = await localforage.getItem(key)
    const mostRecentSearches = pipe(prepend(recentSearch), take(2))(recentSearches)
    return localforage.setItem(key, mostRecentSearches)
  } catch {
    return localforage.setItem(key, [recentSearch])
  }
}
